import styled, { css, RuleSet } from 'styled-components';
import { COLOURS, FONT_WEIGHT, getBodyFont, isFocused, SPACES } from '@belong/themes';

interface IChipStateProps {
  isSelected?: boolean;
  isError?: boolean;
}
type IGetChipStateStyles = (isHover?: boolean) => (props: IChipStateProps) => RuleSet;

const getChipStateStyles: IGetChipStateStyles =
  isHover =>
  ({ isSelected, isError }) => {
    if (isHover) {
      if (isError) {
        return css`
          border-color: ${COLOURS.DARK_RED};
          background: ${COLOURS.DARK_RED};
          color: ${COLOURS.WHITE};
        `;
      }

      if (isSelected) {
        return css`
          border-color: ${COLOURS.BELONG_BLUE_ALT};
          background: ${COLOURS.GREY_100};
          color: ${COLOURS.BELONG_BLUE_ALT};
        `;
      }

      return css`
        border-color: ${COLOURS.BELONG_BLUE_ALT};
        background: ${COLOURS.BELONG_BLUE_ALT};
        color: ${COLOURS.WHITE};
      `;
    }

    if (isError) {
      return css`
        border-color: ${COLOURS.DARK_RED};
        background: ${COLOURS.LIGHT_RED};
        color: ${COLOURS.BLACK};
      `;
    }

    if (isSelected) {
      return css`
        border-color: ${COLOURS.BELONG_BLUE_ALT};
        background: ${COLOURS.BELONG_BLUE_ALT};
        color: ${COLOURS.WHITE};
      `;
    }

    return css`
      border-color: ${COLOURS.GREY_500};
      background: ${COLOURS.GREY_100};
      color: ${COLOURS.BLACK};
    `;
  };

export const LabelChip = styled.label<Omit<IChipStateProps, 'isHover'>>`
  display: flex;
  padding: ${SPACES.small}rem;
  justify-content: center;
  align-items: center;
  gap: ${SPACES.xsmall}rem;
  align-self: stretch;
  white-space: nowrap;
  border-radius: 999.9rem;
  border-width: 2px;
  border-style: solid;
  ${getBodyFont('medium')}
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};
  ${getChipStateStyles(false)}
  &:hover {
    cursor: pointer;
    ${getChipStateStyles(true)}
  }
  &:focus-within {
    ${isFocused()};
  }
`;

export const HiddenInput = styled.input`
  position: absolute;
  top: auto;
  overflow: hidden;
  clip: rect(0.1rem, 0.1rem, 0.1rem, 0.1rem);
  width: 0.1rem;
  height: 0.1rem;
  white-space: nowrap;
`;
